export let TokenVariant = /*#__PURE__*/function (TokenVariant) {
  TokenVariant["Default"] = "default";
  TokenVariant["Standard"] = "standard";
  TokenVariant["Primary"] = "primary";
  TokenVariant["Secondary"] = "secondary";
  return TokenVariant;
}({});
//# sourceMappingURL=types.js.map